export enum AlertMode {
    MESSAGE = 'message',
    EMAIL = 'email',
}
